"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnquiryControllerGetMyEnquiriesV1StatusEnum = exports.EnquiryControllerGetMyEnquiriesV1TypeEnum = exports.EnquiryControllerGetEnquirySourceStatsV1FilterEnum = exports.EnquiryApi = void 0;
var runtime = __importStar(require("../runtime"));
var index_1 = require("../models/index");
/**
 *
 */
var EnquiryApi = /** @class */ (function (_super) {
    __extends(EnquiryApi, _super);
    function EnquiryApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Adds a comment message to an enquiry with an optional supporting document file. Only jpg, jpeg, png, and pdf files are allowed. Maximum file size: 10MB. File is optional.
     * Add a comment to an enquiry
     */
    EnquiryApi.prototype.enquiryControllerAddCommentV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, consumes, canConsumeForm, formParams, useForm, urlPath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['id'] == null) {
                            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling enquiryControllerAddCommentV1().');
                        }
                        if (requestParameters['comment'] == null) {
                            throw new runtime.RequiredError('comment', 'Required parameter "comment" was null or undefined when calling enquiryControllerAddCommentV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        consumes = [
                            { contentType: 'multipart/form-data' },
                        ];
                        canConsumeForm = runtime.canConsumeForm(consumes);
                        useForm = false;
                        // use FormData to transmit files using content-type "multipart/form-data"
                        useForm = canConsumeForm;
                        if (useForm) {
                            formParams = new FormData();
                        }
                        else {
                            formParams = new URLSearchParams();
                        }
                        if (requestParameters['comment'] != null) {
                            formParams.append('comment', requestParameters['comment']);
                        }
                        if (requestParameters['file'] != null) {
                            formParams.append('file', requestParameters['file']);
                        }
                        urlPath = "/v1/enquiries/{id}/comment";
                        urlPath = urlPath.replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters['id'])));
                        return [4 /*yield*/, this.request({
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: formParams,
                            }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AddEnquiryCommentResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Adds a comment message to an enquiry with an optional supporting document file. Only jpg, jpeg, png, and pdf files are allowed. Maximum file size: 10MB. File is optional.
     * Add a comment to an enquiry
     */
    EnquiryApi.prototype.enquiryControllerAddCommentV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.enquiryControllerAddCommentV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Assigns an agent as the receiver of an enquiry. Validates that the enquiry and agent exist, and that the user has the AGENT role. Updates enquiries.receiver_id. Send enquiryId and agentId in the body.
     * Assign agent to enquiry (admin only)
     */
    EnquiryApi.prototype.enquiryControllerAssignAgentToEnquiryV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['assignAgentToEnquiryBodyDto'] == null) {
                            throw new runtime.RequiredError('assignAgentToEnquiryBodyDto', 'Required parameter "assignAgentToEnquiryBodyDto" was null or undefined when calling enquiryControllerAssignAgentToEnquiryV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/enquiries/assign-agent";
                        return [4 /*yield*/, this.request({
                                path: urlPath,
                                method: 'PATCH',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.AssignAgentToEnquiryBodyDtoToJSON)(requestParameters['assignAgentToEnquiryBodyDto']),
                            }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AssignAgentToEnquiryResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Assigns an agent as the receiver of an enquiry. Validates that the enquiry and agent exist, and that the user has the AGENT role. Updates enquiries.receiver_id. Send enquiryId and agentId in the body.
     * Assign agent to enquiry (admin only)
     */
    EnquiryApi.prototype.enquiryControllerAssignAgentToEnquiryV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.enquiryControllerAssignAgentToEnquiryV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates a document request enquiry. If a listingId is provided, the enquiry will be routed to the appropriate receiver (agent or property owner) based on the listing configuration. If no listingId is provided, the enquiry will be sent to admin.
     * Create a document request enquiry
     */
    EnquiryApi.prototype.enquiryControllerCreateDocumentRequestEnquiryV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['documentRequestEnquiryInputDto'] == null) {
                            throw new runtime.RequiredError('documentRequestEnquiryInputDto', 'Required parameter "documentRequestEnquiryInputDto" was null or undefined when calling enquiryControllerCreateDocumentRequestEnquiryV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/enquiries/document-request";
                        return [4 /*yield*/, this.request({
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.DocumentRequestEnquiryInputDtoToJSON)(requestParameters['documentRequestEnquiryInputDto']),
                            }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.DocumentRequestEnquiryApiResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Creates a document request enquiry. If a listingId is provided, the enquiry will be routed to the appropriate receiver (agent or property owner) based on the listing configuration. If no listingId is provided, the enquiry will be sent to admin.
     * Create a document request enquiry
     */
    EnquiryApi.prototype.enquiryControllerCreateDocumentRequestEnquiryV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.enquiryControllerCreateDocumentRequestEnquiryV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates a general enquiry. If a listingId is provided, the enquiry will be routed to the appropriate receiver (agent or property owner) based on the listing configuration. If no listingId is provided, the enquiry will be sent to admin.
     * Create a general enquiry
     */
    EnquiryApi.prototype.enquiryControllerCreateGeneralEnquiryV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['generalEnquiryInputDto'] == null) {
                            throw new runtime.RequiredError('generalEnquiryInputDto', 'Required parameter "generalEnquiryInputDto" was null or undefined when calling enquiryControllerCreateGeneralEnquiryV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/enquiries/general";
                        return [4 /*yield*/, this.request({
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.GeneralEnquiryInputDtoToJSON)(requestParameters['generalEnquiryInputDto']),
                            }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GeneralEnquiryApiResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Creates a general enquiry. If a listingId is provided, the enquiry will be routed to the appropriate receiver (agent or property owner) based on the listing configuration. If no listingId is provided, the enquiry will be sent to admin.
     * Create a general enquiry
     */
    EnquiryApi.prototype.enquiryControllerCreateGeneralEnquiryV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.enquiryControllerCreateGeneralEnquiryV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates a property valuation enquiry.
     * Create a property valuation enquiry
     */
    EnquiryApi.prototype.enquiryControllerCreatePropertyValuationEnquiryV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, consumes, canConsumeForm, formParams, useForm, urlPath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['renovated'] == null) {
                            throw new runtime.RequiredError('renovated', 'Required parameter "renovated" was null or undefined when calling enquiryControllerCreatePropertyValuationEnquiryV1().');
                        }
                        if (requestParameters['name'] == null) {
                            throw new runtime.RequiredError('name', 'Required parameter "name" was null or undefined when calling enquiryControllerCreatePropertyValuationEnquiryV1().');
                        }
                        if (requestParameters['email'] == null) {
                            throw new runtime.RequiredError('email', 'Required parameter "email" was null or undefined when calling enquiryControllerCreatePropertyValuationEnquiryV1().');
                        }
                        if (requestParameters['propertyDetails'] == null) {
                            throw new runtime.RequiredError('propertyDetails', 'Required parameter "propertyDetails" was null or undefined when calling enquiryControllerCreatePropertyValuationEnquiryV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        consumes = [
                            { contentType: 'multipart/form-data' },
                        ];
                        canConsumeForm = runtime.canConsumeForm(consumes);
                        useForm = false;
                        // use FormData to transmit files using content-type "multipart/form-data"
                        useForm = canConsumeForm;
                        if (useForm) {
                            formParams = new FormData();
                        }
                        else {
                            formParams = new URLSearchParams();
                        }
                        if (requestParameters['lastSoldDate'] != null) {
                            formParams.append('lastSoldDate', requestParameters['lastSoldDate']);
                        }
                        if (requestParameters['lastSoldPrice'] != null) {
                            formParams.append('lastSoldPrice', requestParameters['lastSoldPrice']);
                        }
                        if (requestParameters['renovated'] != null) {
                            formParams.append('renovated', requestParameters['renovated']);
                        }
                        if (requestParameters['description'] != null) {
                            formParams.append('description', requestParameters['description']);
                        }
                        if (requestParameters['name'] != null) {
                            formParams.append('name', requestParameters['name']);
                        }
                        if (requestParameters['email'] != null) {
                            formParams.append('email', requestParameters['email']);
                        }
                        if (requestParameters['countryCode'] != null) {
                            formParams.append('countryCode', requestParameters['countryCode']);
                        }
                        if (requestParameters['phoneNumber'] != null) {
                            formParams.append('phoneNumber', requestParameters['phoneNumber']);
                        }
                        if (requestParameters['lovableExtras'] != null) {
                            formParams.append('lovableExtras', new Blob([JSON.stringify((0, index_1.LovableExtrasDtoToJSON)(requestParameters['lovableExtras']))], { type: "application/json", }));
                        }
                        if (requestParameters['propertyDetails'] != null) {
                            formParams.append('propertyDetails', new Blob([JSON.stringify((0, index_1.PropertyDetailsInputDtoToJSON)(requestParameters['propertyDetails']))], { type: "application/json", }));
                        }
                        if (requestParameters['priceEstimates'] != null) {
                            formParams.append('priceEstimates', new Blob([JSON.stringify((0, index_1.PriceEstimateInputDtoToJSON)(requestParameters['priceEstimates']))], { type: "application/json", }));
                        }
                        if (requestParameters['files'] != null) {
                            requestParameters['files'].forEach(function (element) {
                                formParams.append('files', element);
                            });
                        }
                        urlPath = "/v1/enquiries/property-valuation";
                        return [4 /*yield*/, this.request({
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: formParams,
                            }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Creates a property valuation enquiry.
     * Create a property valuation enquiry
     */
    EnquiryApi.prototype.enquiryControllerCreatePropertyValuationEnquiryV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.enquiryControllerCreatePropertyValuationEnquiryV1Raw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Retrieves a paginated list of comments for a specific enquiry created by the authenticated user, including attached files with signed URLs.
     * Get comments list for an enquiry by user
     */
    EnquiryApi.prototype.enquiryControllerGetCommentsV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['enquiryId'] == null) {
                            throw new runtime.RequiredError('enquiryId', 'Required parameter "enquiryId" was null or undefined when calling enquiryControllerGetCommentsV1().');
                        }
                        queryParameters = {};
                        if (requestParameters['pageNo'] != null) {
                            queryParameters['pageNo'] = requestParameters['pageNo'];
                        }
                        if (requestParameters['pageSize'] != null) {
                            queryParameters['pageSize'] = requestParameters['pageSize'];
                        }
                        if (requestParameters['enquiryId'] != null) {
                            queryParameters['enquiryId'] = requestParameters['enquiryId'];
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/enquiries/comments";
                        return [4 /*yield*/, this.request({
                                path: urlPath,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GetEnquiryCommentsResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Retrieves a paginated list of comments for a specific enquiry created by the authenticated user, including attached files with signed URLs.
     * Get comments list for an enquiry by user
     */
    EnquiryApi.prototype.enquiryControllerGetCommentsV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.enquiryControllerGetCommentsV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieves the details of a specific enquiry.
     * Get an enquiry details
     */
    EnquiryApi.prototype.enquiryControllerGetEnquiryDetailsV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['id'] == null) {
                            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling enquiryControllerGetEnquiryDetailsV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/enquiries/{id}";
                        urlPath = urlPath.replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters['id'])));
                        return [4 /*yield*/, this.request({
                                path: urlPath,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GetEnquiryDetailsApiResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Retrieves the details of a specific enquiry.
     * Get an enquiry details
     */
    EnquiryApi.prototype.enquiryControllerGetEnquiryDetailsV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.enquiryControllerGetEnquiryDetailsV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get enquiry source stats for the current user (counts by source for the given date range). Agents see only their listings; admins see all.
     * Get enquiry source stats
     */
    EnquiryApi.prototype.enquiryControllerGetEnquirySourceStatsV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters['filter'] != null) {
                            queryParameters['filter'] = requestParameters['filter'];
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/enquiries/stats/source";
                        return [4 /*yield*/, this.request({
                                path: urlPath,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GetEnquirySourceStatsApiResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get enquiry source stats for the current user (counts by source for the given date range). Agents see only their listings; admins see all.
     * Get enquiry source stats
     */
    EnquiryApi.prototype.enquiryControllerGetEnquirySourceStatsV1 = function () {
        return __awaiter(this, arguments, void 0, function (requestParameters, initOverrides) {
            var response;
            if (requestParameters === void 0) { requestParameters = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.enquiryControllerGetEnquirySourceStatsV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns paginated enquiries. Normal user: filtered by authenticated user ID from token. Admin: returns all enquiries (no user filter). Use type=property_leads for Property Leads screen. Use type=general_queries for General Queries screen. Optionally filter by status (open, in_progress, resolved). When listingId is provided, type is ignored and all enquiry types for that listing are returned.
     * Get list of my enquiries (property leads, general queries, or by listing)
     */
    EnquiryApi.prototype.enquiryControllerGetMyEnquiriesV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters['pageNo'] != null) {
                            queryParameters['pageNo'] = requestParameters['pageNo'];
                        }
                        if (requestParameters['pageSize'] != null) {
                            queryParameters['pageSize'] = requestParameters['pageSize'];
                        }
                        if (requestParameters['type'] != null) {
                            queryParameters['type'] = requestParameters['type'];
                        }
                        if (requestParameters['status'] != null) {
                            queryParameters['status'] = requestParameters['status'];
                        }
                        if (requestParameters['listingId'] != null) {
                            queryParameters['listingId'] = requestParameters['listingId'];
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/enquiries/list";
                        return [4 /*yield*/, this.request({
                                path: urlPath,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GetMyEnquiriesResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns paginated enquiries. Normal user: filtered by authenticated user ID from token. Admin: returns all enquiries (no user filter). Use type=property_leads for Property Leads screen. Use type=general_queries for General Queries screen. Optionally filter by status (open, in_progress, resolved). When listingId is provided, type is ignored and all enquiry types for that listing are returned.
     * Get list of my enquiries (property leads, general queries, or by listing)
     */
    EnquiryApi.prototype.enquiryControllerGetMyEnquiriesV1 = function () {
        return __awaiter(this, arguments, void 0, function (requestParameters, initOverrides) {
            var response;
            if (requestParameters === void 0) { requestParameters = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.enquiryControllerGetMyEnquiriesV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieves a paginated list of properties with open inspection slots and documents. Supports search by property ID and property title. Documents are filtered by category \"other\" and is_public false. Does not require authentication - logged-in users have properties they own excluded from results.
     * Get list of properties for enquiry form
     */
    EnquiryApi.prototype.enquiryControllerGetPropertiesForEnquiryV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters['pageNo'] != null) {
                            queryParameters['pageNo'] = requestParameters['pageNo'];
                        }
                        if (requestParameters['pageSize'] != null) {
                            queryParameters['pageSize'] = requestParameters['pageSize'];
                        }
                        if (requestParameters['propertyId'] != null) {
                            queryParameters['propertyId'] = requestParameters['propertyId'];
                        }
                        if (requestParameters['propertyTitle'] != null) {
                            queryParameters['propertyTitle'] = requestParameters['propertyTitle'];
                        }
                        if (requestParameters['privateInspectionAllowed'] != null) {
                            queryParameters['privateInspectionAllowed'] = requestParameters['privateInspectionAllowed'];
                        }
                        if (requestParameters['hasOpenInspections'] != null) {
                            queryParameters['hasOpenInspections'] = requestParameters['hasOpenInspections'];
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/enquiries/properties";
                        return [4 /*yield*/, this.request({
                                path: urlPath,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GetPropertiesResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Retrieves a paginated list of properties with open inspection slots and documents. Supports search by property ID and property title. Documents are filtered by category \"other\" and is_public false. Does not require authentication - logged-in users have properties they own excluded from results.
     * Get list of properties for enquiry form
     */
    EnquiryApi.prototype.enquiryControllerGetPropertiesForEnquiryV1 = function () {
        return __awaiter(this, arguments, void 0, function (requestParameters, initOverrides) {
            var response;
            if (requestParameters === void 0) { requestParameters = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.enquiryControllerGetPropertiesForEnquiryV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Sends an email to the document request recipient (document_requests.email) with all requested property documents as attachments. Documents are resolved via enquiries -> document_requests -> document_request_media -> property_media -> media_metadata. Files are fetched from storage and attached to the email (not sent as links).
     * Send enquiry documents email
     */
    EnquiryApi.prototype.enquiryControllerSendEnquiryDocumentsV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['id'] == null) {
                            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling enquiryControllerSendEnquiryDocumentsV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/enquiries/{id}/send-documents";
                        urlPath = urlPath.replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters['id'])));
                        return [4 /*yield*/, this.request({
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.SendEnquiryDocumentsResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Sends an email to the document request recipient (document_requests.email) with all requested property documents as attachments. Documents are resolved via enquiries -> document_requests -> document_request_media -> property_media -> media_metadata. Files are fetched from storage and attached to the email (not sent as links).
     * Send enquiry documents email
     */
    EnquiryApi.prototype.enquiryControllerSendEnquiryDocumentsV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.enquiryControllerSendEnquiryDocumentsV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates the status of an enquiry. Allowed values: open, in_progress, resolved.
     * Update enquiry status
     */
    EnquiryApi.prototype.enquiryControllerUpdateEnquiryStatusV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['id'] == null) {
                            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling enquiryControllerUpdateEnquiryStatusV1().');
                        }
                        if (requestParameters['updateEnquiryStatusBodyDto'] == null) {
                            throw new runtime.RequiredError('updateEnquiryStatusBodyDto', 'Required parameter "updateEnquiryStatusBodyDto" was null or undefined when calling enquiryControllerUpdateEnquiryStatusV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/enquiries/{id}/status";
                        urlPath = urlPath.replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters['id'])));
                        return [4 /*yield*/, this.request({
                                path: urlPath,
                                method: 'PATCH',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.UpdateEnquiryStatusBodyDtoToJSON)(requestParameters['updateEnquiryStatusBodyDto']),
                            }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.UpdateEnquiryStatusResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Updates the status of an enquiry. Allowed values: open, in_progress, resolved.
     * Update enquiry status
     */
    EnquiryApi.prototype.enquiryControllerUpdateEnquiryStatusV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.enquiryControllerUpdateEnquiryStatusV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates is_approved to true or false on the registered_inspection (by inspection id) and marks the linked enquiry status as resolved.
     * Update inspection approval and resolve enquiry
     */
    EnquiryApi.prototype.enquiryControllerUpdateInspectionApprovalV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, urlPath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['id'] == null) {
                            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling enquiryControllerUpdateInspectionApprovalV1().');
                        }
                        if (requestParameters['updateInspectionApprovalBodyDto'] == null) {
                            throw new runtime.RequiredError('updateInspectionApprovalBodyDto', 'Required parameter "updateInspectionApprovalBodyDto" was null or undefined when calling enquiryControllerUpdateInspectionApprovalV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2:
                        urlPath = "/v1/enquiries/{id}/inspection-approval";
                        urlPath = urlPath.replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters['id'])));
                        return [4 /*yield*/, this.request({
                                path: urlPath,
                                method: 'PATCH',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.UpdateInspectionApprovalBodyDtoToJSON)(requestParameters['updateInspectionApprovalBodyDto']),
                            }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.UpdateInspectionApprovalResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Updates is_approved to true or false on the registered_inspection (by inspection id) and marks the linked enquiry status as resolved.
     * Update inspection approval and resolve enquiry
     */
    EnquiryApi.prototype.enquiryControllerUpdateInspectionApprovalV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.enquiryControllerUpdateInspectionApprovalV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return EnquiryApi;
}(runtime.BaseAPI));
exports.EnquiryApi = EnquiryApi;
/**
 * @export
 */
exports.EnquiryControllerGetEnquirySourceStatsV1FilterEnum = {
    Today: 'today',
    ThisWeek: 'this_week',
    ThisMonth: 'this_month',
    ThisYear: 'this_year'
};
/**
 * @export
 */
exports.EnquiryControllerGetMyEnquiriesV1TypeEnum = {
    PropertyLeads: 'property_leads',
    GeneralQueries: 'general_queries'
};
/**
 * @export
 */
exports.EnquiryControllerGetMyEnquiriesV1StatusEnum = {
    InProgress: 'in_progress',
    Open: 'open',
    Resolved: 'resolved'
};
